import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import ViewRecent from "./ViewRecent";
import ViewAllocated from "./ViewAllocated";
import ViewClosed from "./ViewClosed";
import StatusComp from "../../components/StatusComp";

const AdminNotifications = () => {
  const [activeTab, setActiveTab] = useState("Recent");

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("Recent");
  //     localStorage.setItem("Notifications", JSON.stringify("Recent"));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("Notifications", JSON.stringify(type));
  };

  const location = useLocation();
  const data = location.state?.data;
  const type = location?.state?.type;

  console.log("data", data);
  console.log("type", type);

  const navigate = useNavigate();
  const createdAt = moment().format("DD-MM-YYYY");

  return (
    <div className="dashRightView">
      <StatusComp name={"Notifications"} type={"View"} />

      <div className="d-flex ">
        <div className="col-md-4 p-3">
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
              Company Name & Code
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={`${data?.companyName ?? "Ninos"} - ${
                data?.companyId ?? "N001"
              }`}
            />
          </div>

          <div className="p-2 mb-2">
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
              Site Name & Code
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={`${data?.siteName ?? "Robotics"} - ${
                data?.siteCode ?? "R001"
              }`}
            />
          </div>
        </div>
        <div className="col-md-4 p-3">
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
              Site Location
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={data?.siteLocation ?? "Chennai,vadapalani"}
            />
          </div>
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
              Site Admin
            </p>
            <input
              className="input-box w-100"
              readOnly
              value={data?.siteAdminName ?? "Shakthivel"}
            />
          </div>
        </div>
        <div className="col-md-4 p-3">
          <div className="p-2 mb-2">
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-18 mb-1 primary">
              Admin Created On
            </p>
            <input className="input-box w-100" readOnly value={createdAt} />
          </div>
        </div>
      </div>

      <div className="col-md-12 p-3 d-flex ac-js mb-5 gap-5">
        <div className="p-2 mb-2">
          <button
            className="back-btn px-4"
            onClick={() =>
              navigate("/site-report", {
                state: { type: "site-view", data: data },
              })
            }
          >
            View Report
          </button>
        </div>

        <div className="p-2 mb-2">
          <button className="submit-btn px-4">View Notifications</button>
        </div>
        <div className="p-2 mb-2">
          <button
            className="back-btn"
            onClick={() =>
              navigate("/admin-slot-main", {
                state: { type: "site-view", data: data, superAdmin: true },
              })
            }
          >
            View slot days
          </button>
        </div>
        <div className="p-2 mb-2">
          <button
            className="back-btn"
            onClick={() =>
              navigate("/admin-alert-types", {
                state: {
                  type: "site-view",
                  data: data,
                },
              })
            }
          >
            Alert Types
          </button>
        </div>
        <div className="p-2 mb-2">
          <button
            className="back-btn"
            onClick={() =>
              navigate("/admin-cameras", {
                state: {
                  type: "site-view",
                  data: data,
                },
              })
            }
          >
            Cameras
          </button>
        </div>
      </div>

      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "Recent" ? "active" : ""}`}
          onClick={() => handleTab("Recent")}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab === "Allocated" ? "active" : ""}`}
          onClick={() => handleTab("Allocated")}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab === "Closed" ? "active" : ""}`}
          onClick={() => handleTab("Closed")}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab === "Recent" && <ViewRecent site={type} />}
        {activeTab === "Allocated" && <ViewAllocated site={type} />}
        {activeTab === "Closed" && <ViewClosed site={type} />}
      </div>
    </div>
  );
};

export default AdminNotifications;
